import { render, staticRenderFns } from "./file-section.vue?vue&type=template&id=1637d66c&scoped=true&"
import script from "./file-section.vue?vue&type=script&lang=js&"
export * from "./file-section.vue?vue&type=script&lang=js&"
import style0 from "./file-section.vue?vue&type=style&index=0&id=1637d66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637d66c",
  null
  
)

export default component.exports